// extracted by mini-css-extract-plugin
export default {"screen":"screen__yN_8e1784ggR"};